module.exports = __webpack_public_path__ + "img/vender.b5122438.jpg";